import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useStripe, useElements } from "@stripe/react-stripe-js"
import { useSelector, useDispatch } from "react-redux"
import { clearCart } from "../../redux/cartRedux"
import { createOrder } from "../../redux/apiCalls"
// Components
import Button from "../Button/Button"
import { PaymentElement } from "@stripe/react-stripe-js"
// Styles
import { Container, Message, StyledForm } from "./CheckoutForm.styles"
import { useTheme } from "styled-components"

const CheckoutForm = () => {
   const stripe = useStripe()
   const elements = useElements()
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const theme = useTheme()
   const { t } = useTranslation()
   const cart = useSelector((state) => state.cart)
   const user = useSelector((state) => state.user.currentUser)

   const [message, setMessage] = useState(null)
   const [isProcessing, setIsProcessing] = useState(false)

   const handleSubmit = async (e) => {
      e.preventDefault()

      if (!stripe || !elements) {
         return
      }
      setIsProcessing(true)

      const { error, paymentIntent } = await stripe.confirmPayment({
         elements,
         confirmParams: {
            return_url: `${window.location.origin}`,
         },
         redirect: "if_required",
      })
      if (error) {
         setMessage(error.message)
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
         let cartProducts = []
         for (let index = 0; index < cart.products.length; index++) {
            cartProducts.push({
               lineNumber: index + 1,
               model: cart.products[index].model,
               code: cart.products[index].code,
               detailedColor: cart.products[index].detailedColor,
               ean: cart.products[index].ean,
               inventory: cart.products[index].inventory,
               outOfCollection: cart.products[index].outOfCollection,
               collectionSeason: cart.products[index].collectionSeason,
               title: cart.products[index].model,
               size: cart.products[index].size,
               quantity: cart.products[index].quantity,
               unitPrice: cart.products[index].unitPrice,
               info: "",
               imageUrl:
                  theme === "dark"
                     ? cart.products[index].imagesDark[0]
                     : cart.products[index].imagesLight[0],
               productId: cart.products[index].productId,
               variationId: cart.products[index].variationId,
               lineStatus: "pending",
               deliveredQty: 0,
               invoicedQty: 0,
               actualDeliveryDate: null,
               invoicedDate: null,
            })
         }

         const res = await createOrder(
            {
               userId: cart.userId,
               products: cartProducts,
               totalQuantity: cart.totalQuantity,
               discount: cart.discount,
               shippingMethod: cart.shippingMethod,
               shippingPrice: cart.shippingPrice,
               amount: cart.amount,
               deliveryAddress: cart.deliveryAddress,
               invoiceAddress: cart.invoiceAddress,
               status: "pending",
               commentInternal: "",
               commentForCustomer: "",
               carrierUrl: "",
               orderOrigin: "Site internet",
               orderDate: Date.now(),
               paymentTerms: [
                  {
                     paymentMethod: "Card",
                     dueDate: Date.now(),
                     amount: cart.amount,
                     payedAmount: cart.amount,
                     paymentDate: Date.now(),
                     payed: true,
                     paymentCustomerId: null,
                  },
               ],
               salesPerson: "Web",
               paymentConditions: null,
            },
            dispatch,
            user?.accessToken
         )

         if (res === "success") {
            setMessage(t("checkoutForm.message.m1"))
            dispatch(clearCart())
            setTimeout(() => navigate("/account"), 4000)
         } else {
            setMessage(t("checkoutForm.message.m2"))
         }
      } else {
         setMessage(t("checkoutForm.message.m3"))
      }
      setIsProcessing(false)
   }

   return (
      <Container>
         <StyledForm id="payment-form">
            <PaymentElement />
            <Button
               callback={(e) => handleSubmit(e)}
               text={
                  isProcessing
                     ? t("checkoutForm.button.b2")
                     : t("checkoutForm.button.b1")
               }
               disabled={isProcessing || message !== null}
               submit
            />
            {message && <Message>{message}</Message>}
         </StyledForm>
      </Container>
   )
}

export default CheckoutForm
